module.exports = __webpack_public_path__ + "img/9.fdc451e4.png";